module.exports = __webpack_public_path__ + "static/img/shape5.7e931ec4.png";